<template>
  <div class="payment-content">
    <!-- <h1>真菌次生代谢产物提取物库</h1>
    <h4 style="float: right;color: black; font-weight: bold;" >产品编号：ALDFS</h4>
    <h4 style="font-size: 15px">(Fungal secondary metabolite extract library)</h4> -->
    <el-dialog
      title="请用微信扫码支付"
      :visible.sync="dialogVisible1"
      width="50%"
      height="60%"
      center
    >
      <div class="payment-method">
        <img :src="codeUrl" style="width: 60%; height: 50%" />
      </div>
    </el-dialog>
    <div style="position: relative; float: right">
      <el-button
        type="primary"
        style="
          position: absolute;
          top: 30px;
          right: 0;
          height: 40px;
          width: 150px;
        "
        @click="openDialog"
        v-show="isPhone == false"
        >购买</el-button
      >
      <h4 style="color: black; font-weight: bold">产品编号：ALDFS</h4>
    </div>
    <h1>真菌次生代谢产物提取物库</h1>
    <h4 style="font-size: 15px">
      (Fungal secondary metabolite extract library)
    </h4>
    <br />
    <p style="font-size: 16px">
      自然界中生物体产生的天然产物已被用作药物已经有数千年。早在公元前二世纪使用青蒿植物来治疗疟疾。另外近代早期的微生物学导致了从微生物中发现了大量的药物，最著名的如亚历山大·弗莱明发现的青霉素。当前真菌仍然是治疗传染病药物的最大来源。与其他天然产物资源相比，真菌具有以下优势。首先，真菌种类繁多，已描述的真菌种类约有
      120,000
      种和510万种未知真菌。其次，真菌可以产生结构广泛和多样的次级代谢产物。最后大规模发酵可生产大量的真菌次生代谢产物。近年来基因组测序技术的快速发展和更多的生物合成基因簇的挖掘，加速发现了更多来自真菌的新化合物。真菌可以从土壤、水、空气、植物或其他生物体中分离出来。尤其，植物的内生真菌可以产生与其宿主相近的次级代谢产物。生物多样化的真菌库对学术研究和工业界至关重要。澳岚丁通过多年的努力建立了一个样品来自全球且具有高度生物多样性的真菌库以促进新药的发现。
    </p>
    <img src="./images/img1.png" style="width: 100%" />
    <!-- <br/>
    <p style="font-size: 16px">
      澳岚丁真菌抽提物药物筛选板（Fungal Extract Drug Screening Plate）是利用澳岚丁真菌库最新开发的一种用于筛选具有药物活性的真菌天然产物的实验工具。这种筛选板可以帮助研究人员快速、有效地发现新型药物活性物质。
    </p>
    <p style="font-size: 16px; color: rgb(175, 8, 8)">
      澳岚丁的所有产品和服务仅用于科学研究，我们不为任何个人用途提供产品和服务。
    </p> -->
    <br />
    <!-- <div class="background">
      <h3>产品简介</h3>
      <p class="introduce">包装： 96孔板， 共6块，来自528个真菌菌种或隔离群，真菌种属已知</p>
    </div> -->
    <div class="trait">
      <h3>产品规格#1</h3>
      <p class="introduce">
        96孔板，
        共60块，来自5280个真菌菌种或隔离群，真菌种属尚在测定中，6个月内完成真菌种属鉴定。约1%
        真菌可能复苏困难。
      </p>
      <br />
      <table class="custom-table">
        <tr>
          <th>规格</th>
          <th>浓度</th>
          <th>单价/板</th>
          <th>60块板</th>
          <th>供货周期</th>
        </tr>
        <tr>
          <td>50 μL/孔, 88孔/板</td>
          <td>2 mg/mL</td>
          <td>4980</td>
          <td>298800</td>
          <td>现货</td>
        </tr>
      </table>
    </div>
    <div class="trait">
      <h3>产品规格#2</h3>
      <p class="introduce">
        96孔板，
        共160块，来自14000个真菌菌种或隔离群，真菌种属尚在测定中，一年内完成真菌种属鉴定。约1%
        真菌复苏可能存在困难。
      </p>
      <br />
      <table class="custom-table">
        <tr>
          <th>规格</th>
          <th>浓度</th>
          <th>单价/板</th>
          <th>160块板</th>
          <th>供货周期</th>
        </tr>
        <tr>
          <td>50 μL/孔, 88孔/板</td>
          <td>2 mg/mL</td>
          <td>4980</td>
          <td>796800</td>
          <td>现货</td>
        </tr>
      </table>
    </div>
    <el-dialog
      title="选择规格"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      width="50%"
      height="60%"
      center
    >
      <div class="order-form-container">
        <!-- 规格选择 -->
        <div class="form-section">
          <h4 class="section-title">规格:</h4>
          <el-radio-group v-model="chooseType" class="spec-radio-group">
            <el-radio-button label="50 μL/孔, 88孔/板"
              >50 μL/孔, 88孔/板</el-radio-button
            >
          </el-radio-group>
        </div>
        <!-- 数量选择 -->
        <div class="form-section">
          <h4 class="section-title">购买数量(板)::</h4>
          <el-input-number
            v-model="chooseCount"
            :min="1"
            :max="1000"
            class="quantity-input"
            :controls-position="isMobile ? 'right' : ''"
          >
          </el-input-number>
        </div>

        <!-- 价格显示 -->
        <div class="form-section">
          <h4 class="section-title">总计价格:</h4>
          <el-input v-model="price" disabled class="price-input">
            <template slot="append">元</template>
          </el-input>
        </div>

        <!-- 地址信息 -->
        <div class="form-section address-section">
          <h3 class="section-title">收货地址</h3>

          <!-- 邮箱和手机号 -->
          <div class="address-row">
            <div class="address-field">
              <label><i class="el-icon-tickets"></i> 邮箱地址(可选)</label>
              <el-input
                v-model="emailDddress"
                class="mobile-full-width"
              ></el-input>
            </div>

            <div class="address-field">
              <label><i class="el-icon-mobile-phone"></i> 手机号</label>
              <el-input v-model="phoneNum" class="mobile-full-width"></el-input>
            </div>
          </div>

          <!-- 省市区选择 -->
          <div class="address-row">
            <div class="address-field">
              <label
                ><i class="el-icon-location-outline"></i> 居住省(直辖市)</label
              >
              <el-select
                v-model="addressProvince"
                @change="jy"
                placeholder="请选择"
                class="mobile-full-width"
              >
                <el-option
                  v-for="item in provinceData"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="address-row">
            <div class="address-field">
              <label><i class="el-icon-location-outline"></i> 居住市</label>
              <el-select
                v-model="addressCity"
                placeholder="请选择"
                @change="jy"
                :disabled="directCity.includes(addressProvince)"
                class="mobile-full-width"
              >
                <el-option
                  v-for="item in cityData"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="address-row">
            <div class="address-field">
              <label><i class="el-icon-location-outline"></i> 居住区</label>
              <el-select
                v-model="addressArea"
                placeholder="请选择"
                @change="jy"
                class="mobile-full-width"
              >
                <el-option
                  v-for="item in areaData"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <!-- 详细地址 -->
          <div class="address-row">
            <div class="address-field full-width">
              <label><i class="el-icon-office-building"></i> 详细地址</label>
              <el-input
                v-model="addressToil"
                class="mobile-full-width"
                maxlength="50"
                show-word-limit
              ></el-input>
            </div>
          </div>

          <div class="address-row">
            <div class="address-field full-width">
              <label
                ><i class="el-icon-office-building"></i> 优惠折扣码(可选)</label
              >
              <el-input
                v-model="discountCode"
                class="mobile-full-width"
                maxlength="50"
                show-word-limit
              ></el-input>
            </div>
          </div>
        </div>

        <!-- 运费说明 -->
        <div class="form-section note-section">
          <p class="note-text">注:江浙沪 10 其余地区 20 新疆等偏远地区 50</p>
        </div>
        <div class="payment-method">
          <h3>支付方式</h3>
          <div class="radio-group">
            <label class="radio-option">
              <input type="radio" v-model="selectedPayment" value="alipay" />
              <span class="radio-label" v-show="this.isMobile == false"
                >支付宝支付</span
              >
              <img :src="liicon" alt="支付宝" class="payment-icon" />
            </label>

            <label class="radio-option">
              <input type="radio" v-model="selectedPayment" value="wechat" />
              <span class="radio-label" v-show="this.isMobile == false"
                >微信支付</span
              >
              <img :src="weicon" alt="微信支付" class="payment-icon" />
            </label>
          </div>
        </div>
      </div>
      <!-- <span>
          <div style="display: flex;flex-direction: column;row-gap: 5px;">
            <h4>规格:</h4>
            <el-radio-group v-model="chooseType">
              <el-radio-button label="80ml/瓶">80ml/瓶</el-radio-button>
            </el-radio-group>
            <h4>购买数量(瓶):</h4>
            <el-input-number v-model="chooseCount" :min="1" :max="1000"></el-input-number>
            <h4>总计价格:</h4>
            <el-input v-model="price" disabled style="width: 200px;">
              <template slot="append">元</template>
            </el-input>
            <el-descriptions class="margin-top" title="收货地址" :column="3" :size="size" border>
                <template slot="extra">
                </template>
                <el-descriptions-item>
                  <template slot="label">
                    <i class="el-icon-tickets"></i>
                    邮箱地址
                  </template>
                  <el-input v-model="emailDddress"></el-input>
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    <i class="el-icon-mobile-phone"></i>
                    手机号
                  </template>
                  <el-input v-model="phoneNum"></el-input>
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    <i class="el-icon-location-outline"></i>
                    居住省(直辖市)
                  </template>
                  <div @click="jy">
                    <el-select v-model="addressProvince" placeholder="请选择" @change="jy">
                      <el-option
                        v-for="item in provinceData"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    <i class="el-icon-location-outline"></i>
                    居住市
                  </template>
                  <el-select v-model="addressCity" placeholder="请选择" :disabled="directCity.includes(addressProvince)" @change="jy">
                    <el-option
                      v-for="item in cityData"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    <i class="el-icon-location-outline"></i>
                    居住区
                  </template>
                  <el-select v-model="addressArea" placeholder="请选择" @change="jy"> 
                    <el-option
                      v-for="item in areaData"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    <i class="el-icon-office-building"></i>
                    详细地址
                  </template>
                  <el-input v-model="addressToil" ></el-input>
                </el-descriptions-item>
              </el-descriptions>
              <br/>
              <h3>注:江浙沪 30 其余地区 50 新疆等偏远地区 100</h3>
          </div>
        </span> -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="buy">立即购买</el-button>
        <!-- <el-button type="primary" @click="addToCartItem">加入购物车</el-button> -->
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  judgePostionUrl,
  recordDetailInfo,
  getAddShopCarUrl,
  buyNow,
  getByUsernameUrl,
  getBuyNowUrl,
  getAlipayUrl,
  getProvinceDataUrl,
  getBelongDataUrl,
  getAddReceiveAddressUrl,
  quickBuyUrl,
  getAlipayPhoneUrl,
  wecharUrl,
} from "../../../request/request";
import { deepCopy, generateUniqueId, isMobile } from "../../../utils/index";
import request from "superagent";

export default {
  data() {
    return {
      liicon: require("@/assets/alipay.png"),
      weicon: require("@/assets/wechatpay.png"),
      selectedPayment: "alipay",
      isMobile: false,
      phoneNum: "",
      emailDddress: "",
      size: "",
      isClear: false,
      directCity: ["北京市", "上海市", "天津市", "重庆市"],
      addressProvince: "",
      provinceData: [],
      addressCity: "",
      cityData: [],
      addressArea: "",
      areaData: [],
      addressToil: "",
      discountCode: "",
      dialogVisible: false,
      chooseType: "50 μL/孔, 88孔/板",
      chooseConcentration: "2 mg/mL",
      chooseCount: "",
      price: 0,
      isPhone: false,
      dialogVisible1: false,
      codeUrl: "",
    };
  },
  methods: {
    checkDeviceType() {
      this.isMobile = window.innerWidth <= 768;
    },
    jy() {
      this.isClear = true;
    },
    setAddress() {
      if (
        this.addressProvince == "" ||
        this.addressArea == "" ||
        this.addressToil == ""
      ) {
        this.$notify({
          title: "提示",
          message: "请填写完毕后提交！",
          type: "warning",
        });
        return;
      }
      request
        .post(`${getAddReceiveAddressUrl()}`)
        .send({
          username: sessionStorage.getItem("username"),
          addressProvince: this.addressProvince,
          addressCity: this.addressCity,
          addressArea: this.addressArea,
          addressToil: this.addressToil,
        })
        .end((err, res) => {
          console.log(res);
          console.log(err);
          this.$notify({
            title: "提示",
            message: "编辑成功！",
            type: "success",
          });
        });
    },
    receiveAddress() {
      // await this.fetchProvinceData();
      request.get(`${getProvinceDataUrl()}`).end((err, res) => {
        this.provinceData = res.body.data;
      });
    },
    openDialog() {
      // if(sessionStorage.getItem('username') == null || sessionStorage.getItem('username') == undefined){
      //   this.$notify({
      //     title: '提示',
      //     message: '请登录您的账号',
      //     type: 'warning'
      //   });
      //   this.$store.commit('updateLoginDialogVisiable',true);
      //   return;
      // }
      request.get(`${getProvinceDataUrl()}`).end((err, res) => {
        this.provinceData = res.body.data;
      });
      this.dialogVisible = true;
    },
    handleClose() {
      this.dialogVisible = false;
      console.log("close dialog...");
    },
    buy() {
      // if(this.selectedPayment == 'wechat'){
      //   this.$notify({
      //       title: '提示',
      //       message: '暂不支持微信支付',
      //       type: 'warning'
      //     });
      //     return;
      // }
      if (
        this.phoneNum == "" ||
        this.addressProvince == "" ||
        this.addressArea == "" ||
        this.addressToil == ""
      ) {
        this.$notify({
          title: "提示",
          message: "请设置填写完整信息！",
          type: "warning",
        });
        return;
      }
      const regEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      const regPhone = /^1[3-9]\d{9}$/;
      if (!regPhone.test(this.phoneNum)) {
        this.$notify({
          title: "提示",
          message: "请设置正确格式的手机号",
          type: "warning",
        });
        return;
      }
      let data = {
        id: generateUniqueId(),
        productName: "真菌次生代谢产物提取物库",
        chooseType: this.chooseType,
        chooseCount: this.chooseCount,
        price: this.price,
        emailDddress: this.emailDddress,
        phoneNum: this.phoneNum,
        addressProvince: this.addressProvince,
        addressCity: this.addressCity,
        addressArea: this.addressArea,
        addressToil: this.addressToil,
        discountCode: this.discountCode,
      };
      let url = "";
      if (this.directCity.includes(this.addressProvince)) {
        url = `${judgePostionUrl()}?city=${this.addressProvince}&toil=${
          this.addressToil
        }`;
      } else {
        url = `${judgePostionUrl()}?city=${this.addressCity}&toil=${
          this.addressToil
        }`;
      }
      request.get(`${url}`).end((err, res) => {
        if (res.body.code == 0) {
          this.$notify.error({
            title: "错误",
            message: res.body.msg,
          });
          return;
        }
        if (res.body.data == false) {
          this.$notify.error({
            title: "错误",
            message: "您输入的地址不存在！",
          });
          return;
        }
        request
          .post(`${quickBuyUrl()}`)
          .send(data)
          .end((err, res) => {
            if (this.selectedPayment == "wechat") {
              request
                .get(`${wecharUrl()}?ordersId=${res.body.data.id}`)
                .end((err, res) => {
                  console.log(res.body.data);
                  this.codeUrl =
                    "https://aulandin.top/resource/wechat/" + res.body.data;
                  this.dialogVisible1 = true;
                });
            } else {
              const newWindow = window.open("");
              if (this.isMobile == true) {
                newWindow.location.href = `${getAlipayPhoneUrl()}?ordersId=${
                  res.body.data.id
                }`;
              } else {
                newWindow.location.href = `${getAlipayUrl()}?ordersId=${
                  res.body.data.id
                }`;
              }
              this.$notify({
                title: "提示",
                message: "如无反应请允许浏览器弹出支付页面！",
                type: "warning",
              });
            }
          });
        this.dialogVisible = false;
      });
      // request.get(`${getByUsernameUrl()}?username=${sessionStorage.getItem('username')}`)
      // .end((err,res) => {
      //   if(res.body.code == 0){
      //     this.$notify({
      //       title: '提示',
      //       message: '请设置收货地址！',
      //       type: 'warning'
      //     });
      //     return;
      //   }
      //   let data = {
      //     id: generateUniqueId(),
      //     productName: '驱蚊液',
      //     chooseType: this.chooseType,
      //     chooseCount: this.chooseCount,
      //     price: this.price
      //   };
      //   request.post(`${getBuyNowUrl()}?username=${sessionStorage.getItem('username')}&price=${data.price}`)
      //   .send(data)
      //   .end((err,res) => {
      //       const newWindow = window.open('');
      //       newWindow.location.href = `${getAlipayUrl()}?ordersId=${res.body.data.id}`;
      //   });
      //   let message = buyNow(sessionStorage.getItem('username'),data);
      //   console.log(message);
      //   this.dialogVisible = false;
      // })
    },
    addToCartItem() {
      // let cartItemData = deepCopy(this.$store.state.cartItem);
      request
        .post(
          `${getAddShopCarUrl()}?username=${sessionStorage.getItem("username")}`
        )
        .send({
          id: generateUniqueId(),
          productName: "真菌次生代谢产物提取物库",
          chooseType: this.chooseType,
          chooseCount: this.chooseCount,
          price: this.price,
        })
        .end((err, res) => {
          if (err) {
            console.log(err);
          } else {
            if (res.body.code == 0) {
              this.$notify.error({
                title: "错误",
                message: res.body.msg,
              });
              return;
            }
            this.$notify({
              title: "成功",
              message: "添加成功！",
              type: "success",
            });
          }
        });
      // cartItemData.push({
      //   id: generateUniqueId(),
      //   productName: '真菌次生代谢产物提取物库',
      //   chooseType: this.chooseType,
      //   chooseConcentration: this.chooseConcentration,
      //   chooseCount: this.chooseCount,
      //   price: this.price
      // });
      // this.$store.commit('updateCartItem',cartItemData);
      // this.$store.commit('updateCartItemCount',cartItemData.length);
      this.dialogVisible = false;
      this.chooseType = "50 μL/孔, 88孔/板";
      this.chooseConcentration = "10 mg/mL";
      this.chooseCount = "";
      this.price = 0;
    },
  },
  mounted() {
    this.checkDeviceType();
    recordDetailInfo("产品-真菌次生代谢产物提取物库");
    this.isPhone = isMobile();
  },
  watch: {
    chooseType(newValue, oldValue) {
      switch (newValue) {
        case "50 μL/孔, 88孔/板":
          this.price = 4980 * this.chooseCount;
          break;
        case "200 μL/孔, 88孔/板":
          this.price = 9980 * this.chooseCount;
          break;
      }
    },
    chooseCount(newValue, oldValue) {
      switch (this.chooseType) {
        case "50 μL/孔, 88孔/板":
          this.price = 4980 * newValue;
          break;
        case "200 μL/孔, 88孔/板":
          this.price = 9980 * newValue;
          break;
      }
    },
    addressProvince(newValue, oldValue) {
      if (this.isClear == true) {
        this.addressCity = "";
        this.addressArea = "";
        this.addressToil = "";
      }
      request.get(`${getBelongDataUrl()}?name=${newValue}`).end((err, res) => {
        if (this.directCity.includes(newValue)) {
          this.areaData = res.body.data;
        } else {
          this.cityData = res.body.data;
        }
      });
    },
    addressCity(newValue, oldValue) {
      if (this.isClear == true) {
        this.addressArea = "";
        this.addressToil = "";
      }
      request.get(`${getBelongDataUrl()}?name=${newValue}`).end((err, res) => {
        this.areaData = res.body.data;
      });
    },
    addressArea(newValue, oldValue) {
      if (this.isClear == true) {
        this.addressToil = "";
      }
    },
  },
};
</script>

<style lang="less" scoped>
.payment-method {
  max-width: 400px;
  margin: 20px auto;
  padding: 20px;
  border: 1px solid #eee;
  border-radius: 8px;
}

.radio-group {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 15px;
}

.radio-option {
  display: flex;
  align-items: center;
  padding: 10px 15px;
  border: 1px solid #ddd;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s;
}

.radio-option:hover {
  border-color: #409eff;
  background-color: #f5f7fa;
}

.radio-option input[type="radio"] {
  margin-right: 10px;
}

.radio-label {
  margin-right: 15px;
  font-size: 16px;
}

.payment-icon {
  width: 24px;
  height: 24px;
  margin-left: auto;
}

.selected-method {
  margin-top: 20px;
  padding: 10px;
  background-color: #f0f9eb;
  color: #67c23a;
  border-radius: 4px;
}

.order-form-container {
  padding: 15px;
  max-width: 100%;
  box-sizing: border-box;
}

.form-section {
  margin-bottom: 20px;
}

.section-title {
  margin: 10px 0;
  font-size: 16px;
  color: #333;
}

.spec-radio-group {
  margin-bottom: 10px;
}

.quantity-input {
  width: 100%;
  max-width: 200px;
}

.price-input {
  width: 100%;
  max-width: 200px;
}

.address-section {
  border: 1px solid #ebeef5;
  padding: 15px;
  border-radius: 4px;
}

.address-row {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 15px;
}

.address-field {
  flex: 1;
  min-width: 100%;
  margin-bottom: 10px;
}

.address-field label {
  display: block;
  margin-bottom: 5px;
  font-size: 14px;
  color: #606266;
}

.address-field.full-width {
  flex: 0 0 100%;
}

.note-section {
  color: #909399;
  font-size: 14px;
}

.mobile-full-width {
  width: 100%;
}

/* 移动端样式 */
@media screen and (max-width: 768px) {
  .section-title {
    font-size: 15px;
  }

  .address-row {
    flex-direction: column;
  }

  .address-field {
    min-width: 100%;
    margin-right: 0;
  }

  .quantity-input,
  .price-input {
    max-width: 100%;
  }

  .el-input-number {
    width: 100%;
  }

  .el-select {
    width: 100%;
  }
}

/* PC端样式 */
@media screen and (min-width: 769px) {
  .address-row {
    flex-direction: row;
  }

  .address-field {
    min-width: calc(50% - 10px);
    margin-right: 10px;
  }

  .address-field:last-child {
    margin-right: 0;
  }
}
.custom-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 16px;
}
.custom-table th,
.custom-table td {
  border: 1px solid black;
  padding: 0px;
  text-align: center;
}
.custom-table th {
  background-color: #2596dc;
  color: white;
}

.payment-content {
  margin-left: -1px;
  .background {
    margin-bottom: 64px;
    h4 {
      margin: 32px 0 16px 0;
    }
  }
  .trait {
    h3 {
      margin: 20px 0 40px 0;
      font-size: 22px;
    }
    ul {
      .trait-tit {
        list-style: disc;
        margin-left: 15px;
        color: #414d5a;
      }
      .pay {
        margin: 30px 0 62px 0;
        line-height: 39px;
        span {
          margin-left: 5px;
        }
      }
      .box-card {
        img {
          margin-left: 20px;
        }
        span {
          display: inline-block;
          width: 84px;
          font-size: 22px;
          margin-left: 25px;
          vertical-align: middle;
        }
      }
      @media (max-width: 768px) {
        .box-card {
          img {
            margin-left: 10px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/content/product/data.vue